/* WHITELIGGHT111 — header
   Mobile navigation drawer: accessible toggle, focus trap, ESC + overlay close,
   body scroll lock, focus restore. Also publishes the real header height as
   --wl-header-height so sticky anchors clear it. No library. */
(function () {
  "use strict";

  var header = document.querySelector("[data-wl-header]");
  if (!header) return;

  /* ---- Publish header height ---------------------------------------- */
  function setHeight() {
    var h = header.offsetHeight;
    if (h) document.documentElement.style.setProperty("--wl-header-height", h + "px");
  }
  setHeight();
  window.addEventListener("resize", setHeight, { passive: true });
  if ("ResizeObserver" in window) new ResizeObserver(setHeight).observe(header);

  /* ---- Sticky scroll state (hairline underline appears on scroll) --- */
  var onScroll = function () {
    header.classList.toggle("is-scrolled", window.scrollY > 8);
  };
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  /* ---- Drawer ------------------------------------------------------- */
  var toggle = header.querySelector("[data-wl-nav-toggle]");
  var drawer = document.getElementById(toggle && toggle.getAttribute("aria-controls"));
  if (!toggle || !drawer) return;

  var lastFocused = null;
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function focusables() {
    return Array.prototype.filter.call(
      drawer.querySelectorAll(FOCUSABLE),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function open() {
    lastFocused = document.activeElement;
    drawer.hidden = false;
    // allow the browser to paint before transitioning
    requestAnimationFrame(function () {
      drawer.classList.add("is-open");
      header.classList.add("nav-is-open");
    });
    toggle.setAttribute("aria-expanded", "true");
    document.documentElement.style.overflow = "hidden";
    document.addEventListener("keydown", onKeydown);
    var f = focusables();
    if (f.length) f[0].focus();
  }

  function close() {
    drawer.classList.remove("is-open");
    header.classList.remove("nav-is-open");
    toggle.setAttribute("aria-expanded", "false");
    document.documentElement.style.overflow = "";
    document.removeEventListener("keydown", onKeydown);
    var done = function () {
      drawer.hidden = true;
      drawer.removeEventListener("transitionend", done);
    };
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      done();
    } else {
      drawer.addEventListener("transitionend", done);
      // safety net if transitionend doesn't fire
      setTimeout(function () { if (!drawer.classList.contains("is-open")) drawer.hidden = true; }, 500);
    }
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function onKeydown(e) {
    if (e.key === "Escape") {
      e.preventDefault();
      close();
      return;
    }
    if (e.key === "Tab") {
      var f = focusables();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  toggle.addEventListener("click", function () {
    if (toggle.getAttribute("aria-expanded") === "true") close();
    else open();
  });

  var overlay = drawer.querySelector("[data-wl-drawer-overlay]");
  if (overlay) overlay.addEventListener("click", close);

  var closeBtn = drawer.querySelector("[data-wl-nav-close]");
  if (closeBtn) closeBtn.addEventListener("click", close);

  // Close the drawer if the viewport grows past the mobile breakpoint.
  var desktop = window.matchMedia("(min-width: 1024px)");
  var onChange = function () {
    if (desktop.matches && toggle.getAttribute("aria-expanded") === "true") close();
  };
  if (desktop.addEventListener) desktop.addEventListener("change", onChange);
  else if (desktop.addListener) desktop.addListener(onChange);
})();
